import Swiper, { Autoplay, Navigation, Pagination, Controller, EffectFade, } from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade]);


import imagesLoaded from 'imagesloaded';


$(document).ready(function($) {
    $('.header__top__wrapper__sandwich').click(function(){
        $(this).toggleClass('change');
        $('.header__bottom__wrapper__navigation-bar').toggle();
    });

    $('#convert').click(function() {
        convert();
    });

    if($('#map-location').length > 0) {
        const lat = $('#map-location').data('lat');

        const lng = $('#map-location').data('lng');

        var smallMap = new google.maps.Map(document.getElementById('map-location'), {
            zoom: 13,
            center: new google.maps.LatLng(lat, lng),
            panControl: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            scrollwheel: false,
            navigationControl: false,
            draggable: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

        new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            map: smallMap,
        });
    }

    if($('#slick-carrousel').length > 0) {
        $('#slick-carrousel picture:first').imagesLoaded(function() {
            var slick = $('#slick-carrousel').slick({
                dots: true,
                infinite: true,
                lazyLoad: 'ondemand',
                speed: 300,
                slidesToShow: 1,
                adaptiveHeight: true,
                prevArrow: '<div class="slick-prev slick-arrow" aria-label="Previous"></div>',
                nextArrow: '<div class="slick-next slick-arrow" aria-label="Next"></div>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                        }
                    },
                ]
            });
        });
    }

    if ($('.swiper-gallery-thumbnails').length > 0) {
        let gallery = new Swiper('.swiper-gallery', {
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            lazy: {
                loadPrevNext: true,
            },
            preloadImages: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
        });

        let galleryThumbs = new Swiper('.swiper-gallery-thumbnails', {
            centeredSlides: true,
            slidesPerView: 'auto',
            slideToClickedSlide: true,
            touchRatio: 0.2,
        });

        gallery.controller.control = galleryThumbs;

        galleryThumbs.controller.control = gallery;

        $('img[usemap]').maphilight({
            fillColor: '000000',
            strokeColor: '000000',
        });

        $('#imgmap area').mouseover(function(e) {
            resetMapArea();

            const slideIndex = $('#' + $(e.target).data('asset')).index();

            if (slideIndex > -1) {
                gallery.slideTo(slideIndex);
            }
        });

        gallery.on('transitionStart', function(e) {
            resetMapArea();
        });

        gallery.on('transitionEnd', function(e) {
            highlightMapArea($('.swiper-slide-active').attr('id'));
        });

        highlightMapArea($('.swiper-slide-active').attr('id'));

        $('.fullscreen-button').click(function(){
            $(document).toggleFullScreen();
        });

        $(document).bind('fullscreenchange', function() {
            if ($(document).fullScreen()) {
                $('.swiper-container').addClass('fullscreen');
            } else {
                $('.swiper-container').removeClass('fullscreen');
            }

            gallery.update();
        });
    }

    $('#languageDropdownButton').click(function(e){
        e.stopPropagation();
        $('#languageDropdown').toggleClass("show");
    });
    $(document).click(function(e){
        e.stopPropagation();
        var dropdown= $('#languageDropdown');
        if(dropdown.has(e.target).length === 0) {
            $('#languageDropdown').removeClass('show');
        }

    });
});

function resetMapArea() {
    const data = {
        fillColor: '000000',
        strokeColor: '000000',
        alwaysOn: false,
        fillOpacity: 0.2,
    };

    $('#imgmap area').data('maphilight', data).trigger('alwaysOn.maphilight');
}

function highlightMapArea(id) {
    const data = {
        fillColor: 'f38e00',
        strokeColor: 'f38e00',
        alwaysOn: true,
        fillOpacity: 0.6,
    };

    $('*[data-asset="' + id + '"]').data('maphilight', data).trigger('alwaysOn.maphilight');
}

function convert() {
    var toConvert = $('#amount');

    if (toConvert.val() == '') {
        alert('Molimo da unesete željeni iznos.');

        return;
    }

    if (isNumeric(toConvert.val()) == false) {
        alert('Molimo da upišete isključivo numeričku vrednost.');

        return;
    }

    var calc = Math.round(toConvert.val() * $('#currency-from').val() / $('#currency-to').val() * 10000) / 10000;

    $('#conversion-result').val(calc);
}

function isNumeric(strString) {
    var strValidChars = '0123456789.-';

    var strChar;

    var blnResult = true;

    if (strString.length == 0) return false;

    for (var i = 0; i < strString.length && blnResult == true; i++) {
        strChar = strString.charAt(i);

        if (strValidChars.indexOf(strChar) == -1) {
            blnResult = false;
        }
    }

    return blnResult;
}



